module.exports = __webpack_public_path__ + "static/media/restaurant3.d35ed642.jpg";